import React from "react";
import UlLi, { scrollTo, mountCode, initDeepLinkData, urlChangeHandler} from "js/utilities/sdk-doc-utils";
import { Grid, Row, Col, Table, Label, Glyphicon} from "react-bootstrap";
import { Navigation, Link } from "react-router";
import SDKSidebar from "js/utilities/sdk-sidebar"
import { ZOOM_ICON } from "js/config.jsx";
import CodeBlocks from "js/utilities/sdk-doc-code-blocks";
import DOCKER_ADVANCED_SCREENSHOT from "resources/img/docker-advanced-screenshot.png";


export default React.createClass({
  displayName: "zoom-server-quickstart",
  scrollToGuide : null,
  scrollingEl : null,
  getInitialState: function() {

    return {
      scrollToElement: scrollToElement
    };
    var scrollToElement = initDeepLinkData(this.props);
  },

  componentDidMount: function() {
    mountCode(this);
  },

  componentWillMount() {
    window.addEventListener('popstate', this.urlChanged, false)
  },

  urlChanged() {
    urlChangeHandler();
  },

  render: function() {

    if (this.scrollToGuide && this.scrollingEl)
      scrollTo(this.scrollingEl, this.scrollToGuide);
    this.scrollToGuide = null;

    return (
      <div>
        <div className="dash">
          <div className="workspace">
            <div className="workspace__container server_integration">

              <section id="Introduction">
                <div className="title">
                  <Glyphicon glyph="list" />
                  <h2 id="zoom-server-integration-guide">FaceTec Custom Server Integration Guide</h2>
                </div>
                <p>This guide explores topics related to architecting, integrating, and scaling FaceTec Custom Server SDKs.</p>
                <hr/>
              </section>

              <iframe src="https://docs.google.com/document/d/1_oi1lQqe79_IdYr_0_p4pSemzURO-9w8JJ8knBMEtg4/preview" width="100%" height="100%"></iframe>


              <SDKSidebar menuType="main" title="FaceTec Docker Help"/>

            </div>
          </div>
        </div>
      </div>
    );
  }
});



// WEBPACK FOOTER //
// ./src/js/components/screens/server-integration.jsx